import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { dateToLocaleDateString } from '../../../utils/date-to-locale-date-string';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetStatsEnvironment } from '../fleet-stats-environment';

/**
 * Gets asset time to activation records
 * @param startDate The start time of the request
 * @param endDate The end time of the request
 * @param metricType 0 for asset assignment, 1 for asset activation
 * @param partnerId ID of the partner
 * @param accountAlias Alias of the account
 * @param resultSmoothing Number designating amount of smoothing to apply to the result
 * @returns Asset Time to Activation Records
 */
export function getDashboardAccountStatsTimeToActivateAsset(
  this: unknown,
  startDate: Date,
  endDate: Date,
  metricType: number,
  partnerId?: null | string,
  accountId?: null | number,
  resultSmoothing?: null | number
) {
  const queryParams = {
    startDate: dateToLocaleDateString(startDate),
    endDate: dateToLocaleDateString(endDate),
    metricType,
  };

  if (typeof partnerId === 'string') {
    Object.assign(queryParams, { partnerId });
  }

  if (typeof accountId === 'number') {
    Object.assign(queryParams, { accountId });
  }

  if (typeof resultSmoothing === 'number') {
    Object.assign(queryParams, { resultSmoothing });
  }

  const query = Object.entries(queryParams)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          fleetStatsEnvironment.resolve(this)
            .dashboardAccountStatsTimeToActivateAssetUrl
        }?${query}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        totalAverageForPeriod: z.number(),
        totalNumberOfAssetsInResult: z.number(),
        averageByMonthList: z.array(
          z.object({
            year: z.number(),
            month: z.number(),
            average: z.number(),
            numberOfAssetsInResult: z.number(),
          })
        ),
      })
    )
  );
}
